import dayjs from 'dayjs'
import { Card } from '@/components/ui/card'
import { ArrowRight } from '@/components/icons'
import { TaskStatusBadge, type TaskStatus } from '@/components/TaskStatusBadge'

interface ChecklistCardProps {
  name: string
  status: TaskStatus
  submittedByName?: string | null
  submittedAt?: Date | string | null
  tripName?: string | null
  departureAirportIcao?: string | null
  arrivalAirportIcao?: string | null
  aircraftRegistration?: string | null
  onClick?: () => void
}

export function ChecklistCard({
  name,
  status,
  submittedByName,
  submittedAt,
  tripName,
  departureAirportIcao,
  arrivalAirportIcao,
  aircraftRegistration,
  onClick,
}: ChecklistCardProps) {
  const date = submittedAt ? dayjs(submittedAt).format('DD MMM YYYY') : null
  const subtitle = [submittedByName, date].filter(Boolean).join(' • ')
  const hasRoute = !!departureAirportIcao && !!arrivalAirportIcao

  return (
    <Card interactive onClick={onClick} className="border-[0.5px] border-border-L1">
      <div className="flex w-full items-center gap-3">
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <p className="truncate text-base font-semibold leading-6 tracking-[-0.5px] text-content-primary-bold">
            {name}
          </p>
          {(tripName || hasRoute || aircraftRegistration) && (
            <div className="flex items-center gap-2 text-xs leading-4 text-content-primary-subtle">
              {tripName && <span className="truncate">{tripName}</span>}
              {hasRoute && (
                <span className="flex shrink-0 items-center gap-1">
                  <span>{departureAirportIcao}</span>
                  <ArrowRight className="size-3 text-content-primary-subtle-mid" />
                  <span>{arrivalAirportIcao}</span>
                </span>
              )}
              {aircraftRegistration && (
                <span className="shrink-0">{aircraftRegistration}</span>
              )}
            </div>
          )}
          {subtitle && (
            <p className="truncate text-xs leading-4 text-content-primary-subtle">
              {subtitle}
            </p>
          )}
        </div>
        <TaskStatusBadge status={status} className="shrink-0" />
      </div>
    </Card>
  )
}
